import LimitedButton from '../Elements/LimitedButton';
import CtaButton from '../Elements/CtaButton';
class CtaController {
  constructor() {
    this.initializeElements();
  }

  initializeElements() {
    this.initializeElement('.cta-limited-button', LimitedButton);
	  this.initializeElement('.cta-button', CtaButton);
  }

  initializeElement(elementSelector, elementClass) {
    let $element = $(elementSelector);
    if ($element.length > 0) {
      new elementClass($element);
    }
  }
}

export default CtaController;
